module.exports = __webpack_public_path__ + "static/media/img-2.27e4bb92.png";